/* eslint-disable max-lines-per-function */
import { Button } from '@/components/ui/button';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { YearMonthParams } from '@/domain/termine/type';
import { getMonthNameByDate } from '@/utils/dateFunctions/getDatesOfMonth';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { YearMonthPopoverContent } from '@/domain/termine/components/YearMonthPicker/YearMonthPopoverContent';
import { YearMonthPickerDrawerContent } from './YearMonthPickerDrawerContent';

interface YearMonthDrawerMobileProps {
  currentMonthAndYear?: YearMonthParams;
  onSelect?: (year: number, month: number) => void;
  triggerClassName?: string;
  children?: React.ReactNode;
}

export function YearMonthDrawerMobile({
  currentMonthAndYear: propMonthAndYear,
  onSelect,
  triggerClassName,
  children,
}: YearMonthDrawerMobileProps) {
  const { t } = useTranslation();
  const params = useParams();

  const currentMonthAndYear = propMonthAndYear ?? {
    year: params.year,
    month: params.month,
  };

  const monthYearName = currentMonthAndYear.year + currentMonthAndYear.month;
  const useRouterNavigation = !onSelect;

  const handleSelect = () => {
    // Empty callback for YearMonthPopoverContent when using router navigation
  };

  return (
    <Drawer>
      <DrawerTrigger asChild>
        {children || (
          <Button
            variant="ghost"
            className={
              triggerClassName ||
              'sm:hover:bg-white sm:active:bg-white sm:data-[state=open]:bg-white'
            }>
            <span className="flex items-center gap-1">
              <span className="font-semibold text-sm">
                {getMonthNameByDate(monthYearName)}
              </span>
            </span>
          </Button>
        )}
      </DrawerTrigger>
      <DrawerContent>
        <div className="w-full p-4" data-vaul-no-drag>
          {useRouterNavigation ? (
            <YearMonthPopoverContent
              currentMonthAndYear={currentMonthAndYear}
              onSelect={handleSelect}
            />
          ) : (
            <YearMonthPickerDrawerContent
              currentMonthAndYear={currentMonthAndYear}
              onSelect={onSelect!}
            />
          )}
        </div>
        <div className="p-4">
          <DrawerClose asChild>
            <Button className="w-full" size="lg">
              {t('domain.termine.form.fertig')}
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
